import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MapPin, ClipboardList, Camera, AlertTriangle } from "lucide-react";

export const FieldDashboardView = () => {
  const { user } = useAuth();

  const { data: projects = [] } = useQuery({
    queryKey: ["field_projects", user?.id],
    queryFn: async () => {
      const { data } = await supabase
        .from("projects")
        .select("id, name, project_number, location, city, state")
        .eq("status", "active")
        .limit(6);
      return data ?? [];
    },
    enabled: !!user,
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">My Jobs Today</h1>

      {projects.length === 0 ? (
        <div className="py-12 text-center text-muted-foreground">No active jobs assigned</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {projects.map((p: any) => (
            <Card key={p.id} className="border-2">
              <CardHeader className="pb-2">
                <div className="flex items-center gap-2">
                  {p.project_number && (
                    <Badge variant="secondary" className="text-xs">{p.project_number}</Badge>
                  )}
                  <CardTitle className="text-base">{p.name}</CardTitle>
                </div>
                {(p.city || p.state) && (
                  <p className="text-xs text-muted-foreground flex items-center gap-1">
                    <MapPin className="h-3 w-3" /> {[p.city, p.state].filter(Boolean).join(", ")}
                  </p>
                )}
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="text-xs text-muted-foreground uppercase tracking-wide font-semibold">
                  Materials Status
                </div>
                <p className="text-sm text-muted-foreground italic">No work orders linked yet</p>

                <div className="flex gap-2 flex-wrap">
                  <Button size="sm" variant="outline">
                    <ClipboardList className="h-3.5 w-3.5 mr-1" /> Daily Report
                  </Button>
                  <Button size="sm" variant="outline">
                    <Camera className="h-3.5 w-3.5 mr-1" /> Photos
                  </Button>
                  <Button size="sm" variant="outline">
                    <AlertTriangle className="h-3.5 w-3.5 mr-1" /> Flag Issue
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
